"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.redTheme = void 0;
// import { blend } from "chroma-js";
var shared_1 = require("./shared");
var colors = {
    primary: "#EE312F",
    disabled: "#EAEAEA",
};
exports.redTheme = __assign(__assign({}, shared_1.sharedTheme), { buttonRadius: 5, inputRadius: 5, checkboxRadius: 5, cardRadius: 10, modalRadius: 15, gray1: "#333333", gray2: "#AFAFAF", gray3: colors.disabled, gray4: "#F8F8F8", positive: "#2CBE69", positive2: "#C9F7DC", font: "Lato", primaryColor: colors.primary, dm__primaryColor: "#EE312F", secondaryColor: "#FFFF00", dm__secondaryColor: "#FFFF00", headerColor: "#111111", background: "#FFF", dm__background: "#232225", colorBackground: "#E60037", dm__colorBackground: "#E60037", cardBackgroundColor: shared_1.sharedTheme.gray5, dm__cardBackgroundColor: shared_1.sharedTheme.gray1, outlineButtonColor: colors.primary, dm__textColor: "#FFF", textColor: "#333", primaryButtonDisabled: colors.disabled, inputBg: shared_1.sharedTheme.white });
exports.default = exports.redTheme;
